import { createAction, props } from "@ngrx/store";
import { ISupplier } from "../models/suppliers.models";
import { IPageCount } from "src/app/shared/models/page.model";
import { APIResponse } from "src/app/core/models/api-response";

// fetch suppliers
export const FetchSuppliers = createAction(
  '[ Suppliers ] - FetchSuppliers',
  props<{ page: IPageCount; key?: string | undefined }>()
);
export const FetchSuppliersSuccess = createAction(
  '[ Suppliers ] - FetchSuppliers Success ',
  props<{ suppliers: APIResponse<ISupplier> }>()
);
export const FetchSuppliersError = createAction(
  '[ Suppliers ] - FetchSupplier Error',
);

// add supplier
export const AddSupplier = createAction(
  '[ Supplier ] - AddSupplier',
  props<{ supplier: ISupplier, index?: number }>()
);
export const AddSupplierSuccess = createAction(
  '[ Supplier ] - AddSupplier Success ',
  props<{ supplier: ISupplier | undefined, index?: number }>()
);
export const AddSupplierError = createAction(
  '[ Supplier ] - AddSupplier Error',
);

// loader actions
export const SetSupplierLoader = createAction(
  '[ Suppliers ] - SetLoading',
  props<{ isLoading: boolean }>()
);

// search
export const SetSupplierSearch = createAction(
  '[ Search ] - SetSupplierSearch',
  props<{ search: string }>()
);
